import { type NodeViewProps } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { useEffect, useRef, useState } from 'react';

function hasNonEditableAncestor(element: HTMLElement | null): boolean {
  if (element == null) {
    return false;
  }

  let current = element.parentElement;
  while (current != null) {
    if (current.getAttribute('contenteditable') === 'false') {
      return true;
    }
    current = current.parentElement;
  }
  return false;
}

export function ContentParagraphView(props: NodeViewProps) {
  const {
    textAlign,
    hideDragHandle = false,
    isChild = false,
    isDirectChildOfDoc = true,
  } = props.node.attrs;
  const position = props.getPos();
  const thisParagraph =
    typeof position === 'number' ? props.editor.state.doc.resolve(position) : null;
  const style = textAlign == null ? {} : { textAlign: textAlign as string };
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [hasNonEditableParent, setHasNonEditableParent] = useState(false);

  useEffect(function checkAncestors() {
    setHasNonEditableParent(hasNonEditableAncestor(wrapperRef.current));
  }, []);

  if (
    isDirectChildOfDoc === false ||
    props.node.firstChild?.type.name === 'image' ||
    thisParagraph?.parent?.type?.name === 'listItem'
  ) {
    return (
      <NodeViewWrapper>
        <NodeViewContent style={style}></NodeViewContent>
      </NodeViewWrapper>
    );
  }
  const shouldHideDragHandle = hideDragHandle === true;

  return (
    <NodeViewWrapper
      ref={wrapperRef}
      className={`group relative flex items-start justify-end ${isChild === true ? 'w-full px-0' : 'px-8'}`}
    >
      {shouldHideDragHandle ? null : (
        <div
          className={`font-body-2-m absolute left-[0.5rem] top-1 flex h-1.5 w-1.5 select-none items-center justify-center text-branding-gray-600 ${hasNonEditableParent ? '' : 'group-hover:hidden'}`}
          contentEditable={false}
        >
          P
        </div>
      )}
      <NodeViewContent
        className={`${isChild === true ? 'w-full' : 'w-full max-w-[800px]'}`}
        style={style}
      />
    </NodeViewWrapper>
  );
}
